import React, { useState } from "react";
import BackButton from "./BackButton";
import './MpinForm.css';
import { useNavigate } from "react-router-dom";
import { verifyOtp } from "../../features/userSlice";
import { msgAccessPromt } from "../../constant/constant";
import { useDispatch } from "react-redux";
import { faMobileScreen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const OtpForm = () => {
    const [mpin, setMpin] = useState(["", "", "", ""]);
    const navigate = useNavigate();
    const dispatch=useDispatch();
    const handleInputChange = (index, value, type) => {
        if (!/^\d*$/.test(value)) return; // Restrict to digits only
        const updatedValues = [...mpin] ;

       if(updatedValues[index]==='' || value===''){
            updatedValues[index] = value;
            setMpin(updatedValues);
         }
        // Automatically move to the next input
        if (value && index < 5) {
            const nextInput = document.getElementById(`${type}-${index + 1}`);
            if (nextInput) nextInput.focus();
        }
    };

    const handleNav = () => {
        navigate('/login'); 
    };


    const handleSubmit = async(e) => {
              let val=0;
             msgAccessPromt({dispatch,msg:'LOADING',error:true});
               if(!(mpin[0] && mpin[1] && mpin[2] && mpin[3]))
                {
                    msgAccessPromt({dispatch,error:true,msg:'Only 4 digit allow !!'});
                    return false;
                    }else{
                        val=mpin.reduce((acc, num) => parseInt(acc + num), 0);;
                    }
            e.preventDefault();
            let phone =localStorage.getItem("phone_number");
            let dataSet = new FormData();
            dataSet.append('phone_number',phone);
            dataSet.append('otp', val);
            
    
            try {
                const data = await dispatch(verifyOtp(dataSet)).unwrap(); // Unwrap to get the resolved value
                if(data.status==='success'){
                    msgAccessPromt({dispatch,error:false,msg:data.message});
                    navigate("/sign-up");
                    
                }else{
                    msgAccessPromt({dispatch,error:true,msg:data.message});

                }
            } catch (error) {
                console.error('API Error:', error);
                msgAccessPromt({dispatch,error:true,msg:'Api Error'});
    
            }
            
        };

        
    return (
        <div className="bodyDiv">
        <div className="mpin-container">
           <BackButton></BackButton>
           <div style={{marginTop:'36%'}}>
           <div className="title_Form" style={{justifyContent:'space-between'}}>
            <div className="title_left">
                <h1 className="main_title">ENTER OTP</h1>
                    <p>Verify your mobile number</p>
                    </div>
                    <div className="title_right">
                    <FontAwesomeIcon icon={faMobileScreen} color="#007bff" size="3x" padding='3%' />
                </div>
              </div>
            
            <div className="input-group">
                <div className="mpin-input">
                    {mpin.map((value, index) => (
                        <input
                            key={index}
                            id={`mpin-${index}`}
                            className="input_lable_deep"
                            type="number"
                            maxLength="1"
                            value={value}
                            onChange={(e) => handleInputChange(index, e.target.value, "mpin")}
                        />
                    ))}
                </div>
            </div>
            <button className="generate-mpin-button" onClick={handleSubmit}>VERIFY</button><br/><br/><br/>
            
            <p className="signin-link">Have an account? <a href="javascript:void(0)" onClick={handleNav}>Sign In</a></p>
        </div>
        </div>
        </div>
    );
};

export default OtpForm;


